import { render, staticRenderFns } from "./WCheckbox.vue?vue&type=template&id=56258fb8&"
import script from "./WCheckbox.vue?vue&type=script&lang=js&"
export * from "./WCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports